import $axios from '@/core/api-config'
import icons from '@/core/icons'

class BookService {
  getBooks () {
    return $axios.get('/api/books/')
  }

  getById (id) {
    return $axios.get(`/api/books/book/${id}`)
  }

  getDeleted () {
    return $axios.get('/api/books/deleted')
  }

  create (data) {
    data.icon = data.icon || icons.getBookIcon()
    return $axios.post('/api/books/', data)
  }

  createSection (title) {
    return $axios.post('/api/books/section', { title: title, icon: 'default-phoenix' })
  }

  delete ({ id, isSection }) {
    if (isSection) {
      return $axios.delete(`/api/books/section/${id}`)
    }
    return $axios.delete(`/api/books/${id}`, { data: { permanent: false } })
  }

  permanentDelete (id) {
    return $axios.delete(`/api/books/${id}`, { data: { permanent: true } })
  }

  update ({ id, title, subTitle, color, icon, favorite }) {
    return $axios.put(`/api/books/${id}`, {
      title,
      subTitle,
      color,
      icon,
      favorite
    })
  }

  restore (id) {
    return $axios.post(`/api/books/restore/${id}`)
  }

  order (ids) {
    return $axios.post('/api/books/order/', { ids })
  }

  mentionMember ({ memberId, projectId, bookId, chatId, commentId, taskId, eventId, discussionId, message }) {
    const query = projectId ? `?projectId=${projectId}`
      : discussionId ? `?discussionId=${discussionId}`
        : commentId ? `?commentId=${commentId}`
          : eventId ? `?eventId=${eventId}`
            : chatId ? `?chatId=${chatId}`
              : taskId ? `?taskId=${taskId}`
                : ''

    return $axios.post(`/api/books/mention/${memberId}/${bookId}${query}`, { message })
  }
}

export const bookService = new BookService()
